export const knowledgeDepthOptions = [
  { id: "recall", label: "RECALL", description: "Basic understanding" },
  { id: "conceptual", label: "CONCEPTUAL", description: "Conceptual understanding" },
  { id: "application", label: "APPLICATION", description: "Application" },
  { id: "thinking", label: "THINKING", description: "Thinking / analysis" },
];

export const questionToneOptions = [
  { id: "direct", label: "DIRECT" },
  { id: "scenario", label: "SCENARIO-BASED" },
  { id: "mixed", label: "MIXED" },
];

export const questionCountOptions = [5, 10, 15, 20];

export const generateQuestionsHint =
  "Creates questions in progression from basic understanding to higher-order thinking";

export const defaultConceptQuestionsConfig = {
  selectedConceptId: "",
  selectedConceptLabel: "",
  knowledgeDepth: ["recall", "conceptual", "application", "thinking"],
  questionTone: "mixed",
  questionCount: 10,
  includeAnswerKey: true,
};

export function buildGenerateQuestionsLabel(count) {
  return `Generate ${count} Questions`;
}

export const uploadContentLabel = "UPLOAD CONTENT (PDF, DOC, TXT)";

export const uploadAcceptTypes = ".pdf,.doc,.docx,.txt";

export const uploadFileUploadedLabel = "File Uploaded";

export const uploadReuploadLabel = "Reupload the file";

export const uploadPreviewLabel = "Preview";

export const previewDocumentContent = [
  "Thermodynamics describes how energy moves through systems. The first law states that energy cannot be created or destroyed — only transferred or converted. The second law explains why heat flows from hot to cold objects.",
  "Entropy measures disorder in a system. When energy spreads out, entropy increases. This is why a hot cup of coffee cools down in a room: the thermal energy disperses until the system reaches equilibrium.",
];

export const questionBuilderHeading = "Build progressive concept questions";

export const questionBuilderSubtitle =
  "Generate questions that move from recall to application and analysis";

export const teachingConceptsHeading = "START WITH A CONCEPT YOU'RE TEACHING";

export { familiarTopics as teachingConcepts } from "../shared/familiarTopics";
